import { Link } from "react-router-dom";
import { MessageCircle, Phone, ArrowRight } from "lucide-react";
import { waLink, telLink } from "@/lib/store";

export default function CtaBanner() {
    return (
        <section data-testid="cta-banner" className="bg-safety text-white relative overflow-hidden">
            <div className="absolute inset-0 opacity-20 mix-blend-overlay bg-[radial-gradient(circle_at_20%_50%,rgba(255,255,255,0.3),transparent_40%)]" />
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
                <div className="md:col-span-8">
                    <h3 className="font-display font-extrabold tracking-tight text-3xl md:text-5xl leading-[1.05]">
                        Need wire, pipes or fittings?
                        <br className="hidden md:block" /> Message us — we'll quote in a minute.
                    </h3>
                </div>
                <div className="md:col-span-4 flex flex-wrap md:justify-end gap-3">
                    <a href={waLink()} target="_blank" rel="noreferrer" data-testid="cta-banner-whatsapp">
                        <button className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-white text-safety font-bold hover:bg-white/90 transition">
                            <MessageCircle className="w-4 h-4" /> WhatsApp
                        </button>
                    </a>
                    <a href={telLink()} data-testid="cta-banner-call">
                        <button className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-charcoal text-white font-bold hover:bg-charcoal-800 transition">
                            <Phone className="w-4 h-4" /> Call
                        </button>
                    </a>
                    <Link to="/contact" data-testid="cta-banner-contact">
                        <button className="inline-flex items-center gap-2 h-12 px-5 rounded-full border-2 border-white/60 text-white font-bold hover:bg-white/10 transition">
                            Contact form <ArrowRight className="w-4 h-4" />
                        </button>
                    </Link>
                </div>
            </div>
        </section>
    );
}
